jQuery(document).ready(function ($) {
    $('.js-faq-toggle').on('click', function (event) {
        event.preventDefault();

        $(this).parent().parent().toggleClass('open');
        $(this).parent().next().slideToggle(500);
    });

    const faq_tabs = $('.faqs-block__tab');
    const faq_groups = $('.faqs-block__group');

    $.fn.toggleFAQTab = function () {
        const index = this.attr('data-index');

        faq_groups.hide();
        $(`.faqs-block__group[data-index="${index}"]`).show();

        faq_tabs.removeClass('active');
        this.addClass('active');

        return this;
    }

    faq_tabs.on('click', function (event) {
        event.preventDefault();

        $(this).toggleFAQTab();
    });
});